import Store from '../store/store'
import commonJs from '../common/common.js'
const commonViewJs = {}

/**
 * 房间初始点
 */
commonViewJs.getAx = function () {
  return Store.state.graph.pjX
}
commonViewJs.getAy = function () {
  return Store.state.graph.pjY + Store.state.offset
}
commonViewJs.getAz = function () {
  return Store.state.graph.pjZ
}
/**
 * 投影仪初始点
 */
commonViewJs.getB1x = function () {
  return 0
}
commonViewJs.getB1y = function () {
  return 0
}
commonViewJs.getB1z = function () {
  return 0
}

commonViewJs.getB2x = function () {
  return Store.state.houseInfo.roomW
}
commonViewJs.getB2y = function () {
  return 0
}
commonViewJs.getB2z = function () {
  return 0
}

commonViewJs.getB3x = function () {
  return 0
}
commonViewJs.getB3y = function () {
  return Store.state.houseInfo.roomD
}
commonViewJs.getB3z = function () {
  return 0
}
/**
 * 房间右下角点
 */
commonViewJs.getC1x = function () {
  return 0
}
commonViewJs.getC1y = function () {
  return Store.state.houseInfo.roomD
}
commonViewJs.getC1z = function () {
  return Store.state.houseInfo.roomH
}

commonViewJs.getC3x = function () {
  return Store.state.houseInfo.roomW
}
commonViewJs.getC3y = function () {
  return Store.state.houseInfo.roomD
}
commonViewJs.getC3z = function () {
  return Store.state.houseInfo.roomH
}

commonViewJs.get3D1x = function () {
  return 0
}
commonViewJs.get3D1y = function () {
  return 0
}
commonViewJs.get3D1z = function () {
  return Store.state.houseInfo.roomH
}

commonViewJs.get3D2x = function () {
  return Store.state.houseInfo.roomW
}
commonViewJs.get3D2y = function () {
  return 0
}
commonViewJs.get3D2z = function () {
  return Store.state.houseInfo.roomH
}

commonViewJs.get3D3x = function () {
  return Store.state.houseInfo.roomW
}
commonViewJs.get3D3y = function () {
  return Store.state.houseInfo.roomD
}
commonViewJs.get3D3z = function () {
  return 0
}

commonViewJs.getDx = function () {
  return Store.state.graph.pjX
}
commonViewJs.getDy = function () {
  return Store.state.graph.pjY
}
commonViewJs.getDz = function () {
  return 0
}

commonViewJs.getEx = function () {
  return Store.state.graph.pjX
}
commonViewJs.getEy = function () {
  return Store.state.houseInfo.roomD
}
commonViewJs.getEz = function () {
  return Store.state.graph.pjZ
}

commonViewJs.getFx = function () {
  return Store.state.graph.pjX
}
commonViewJs.getFy = function () {
  return Store.state.graph.pjY
}
commonViewJs.getFz = function () {
  return Store.state.houseInfo.roomH
}

/**
 * G表示水平于发光源A点的坐标
 */
commonViewJs.getGx = function () {
  return Store.state.graph.pjX
}
commonViewJs.getGy = function () {
  return 0
}
commonViewJs.getGz = function () {
  return Store.state.graph.pjZ
}

commonViewJs.getRx = function () {
  return Store.state.houseInfo.roomW
}
commonViewJs.getRy = function () {
  return Store.state.graph.pjY
}
commonViewJs.getRz = function () {
  return Store.state.graph.pjZ
}

commonViewJs.getSx = function () {
  return 0
}
commonViewJs.getSy = function () {
  return Store.state.graph.pjY
}
commonViewJs.getSz = function () {
  return Store.state.graph.pjZ
}

commonViewJs.isHAngle = function () {
  return Store.state.hAngleFlag && Store.state.hAngle !== 0
}
commonViewJs.isVAngle = function () {
  return Store.state.vAngleFlag && Store.state.vAngle !== 0
}

commonViewJs.getScreenByFromDistWide = function (dist) {
  return Store.state.graph.f_d2s.w.a * dist + Store.state.graph.f_d2s.w.b
}

commonViewJs.getScreenByFromDistTele = function (dist) {
  return Store.state.graph.f_d2s.t.a * dist + Store.state.graph.f_d2s.t.b
}

/**
 * 通过距离获取屏幕的x,y
 */
commonViewJs.getScreenXyFromDist = function (dist) {
  var screenSize = this.getScreenByFromDistWide(dist)
  screenSize = screenSize * Store.state.inchCom
  var scrrenL, scrrenW, x
  var aspectRatioNo = Store.state.aspectRatio
  scrrenL = aspectRatioNo.split(':')[0]
  scrrenW = aspectRatioNo.split(':')[1]
  x = Math.sqrt(Math.pow(screenSize, 2) /
  (Math.pow(scrrenL, 2) + Math.pow(scrrenW, 2))
  )
  return {
    calX: scrrenL * x,
    calY: scrrenW * x
  }
}

commonViewJs.getScreenSizeFromDist = function (dist) {
  var screenSize = Store.state.graph.f_d2s.w.a * dist + Store.state.graph.f_d2s.w.b
  screenSize = screenSize * Store.state.inchCom
  var scrrenL, scrrenW, x
  var aspectRatioNo = Store.state.aspectRatio
  scrrenL = aspectRatioNo.split(':')[0]
  scrrenW = aspectRatioNo.split(':')[1]
  x = Math.sqrt(Math.pow(screenSize, 2) /
  (Math.pow(scrrenL, 2) + Math.pow(scrrenW, 2))
  )
  return {
    calX: scrrenL * x,
    calY: scrrenW * x
  }
}

commonViewJs.getInitScreenXyFromDist = function (dist) {
  let distInfoVal = this.filterDistInfoByAspactRatio()
  let dist2size = distInfoVal.dist2size

  var screenSize = dist2size.w.a * dist + dist2size.w.b
  screenSize = screenSize * Store.state.inchCom
  var scrrenL, scrrenW, x
  var aspectRatioNo = Store.state.selectedLensData.lcd.aspectRatio
  scrrenL = aspectRatioNo.split(':')[0]
  scrrenW = aspectRatioNo.split(':')[1]
  x = Math.sqrt(Math.pow(screenSize, 2) /
  (Math.pow(scrrenL, 2) + Math.pow(scrrenW, 2))
  )
  return {
    calX: scrrenL * x,
    calY: scrrenW * x
  }
}
/**
 * 单位格式化(有单位)
 */
commonViewJs.formatData = function (data) {
  if (Store.state.graph.unit === 0) {
    return this.checkData(Number((data / 100).toFixed(3))) ? '' : Number((data / 100).toFixed(3))
  } else if (Store.state.graph.unit === 1) {
    return this.checkData(Number((data * 10).toFixed(0))) ? '' : Number((data * 10).toFixed(0))
  } else if (Store.state.graph.unit === 2) {
    return this.checkData(Number((data / Store.state.inchCom).toFixed(2))) ? '' : Number((data / Store.state.inchCom).toFixed(2))
  }
}

commonViewJs.checkData = function (data) {
  if (!Number(data)) {
    return true
  } else if (Number(data) === 0) {
    return true
  } else if (Number(data) < 0) {
    return true
  } else {
    return false
  }
}
/**
 * 单位格式化(有单位)
 */
commonViewJs.getUnit = function () {
  if (Store.state.graph.unit === 0) {
    return '(m)'
  } else if (Store.state.graph.unit === 1) {
    return '(mm)'
  } else if (Store.state.graph.unit === 2) {
    return '(inch)'
  }
}

/**
 * 取当前throw radio时屏幕长的角度
 */
commonViewJs.getVerAngle = function (dis) {
  var screenX
  if (Store.state.screenSizeChecked || Store.state.realThrowDistanceChecked) {
    screenX = Store.state.graph.scrnW
  } else {
    var lens = this.getScreenSizeFromDist(dis)
    screenX = lens.calX
  }
  return commonJs.getInclinationAngle(screenX / 2 / dis) * 2
}

/**
 * 取初始throw radio时屏幕长的角度
 */
commonViewJs.getInitVerAngle = function (dis) {
  var screenX
  if (Store.state.screenSizeChecked || Store.state.realThrowDistanceChecked) {
    screenX = this.getInitScreenXyFromDist(this.getKy() - Store.state.offset)
    screenX = screenX.calX
  } else {
    var lens = this.getInitScreenXyFromDist(dis)
    screenX = lens.calX
  }
  return commonJs.getInclinationAngle(screenX / 2 / dis) * 2
}

commonViewJs.getScreenXYByScreenSize = function (screenSize, ratio) {
  screenSize = screenSize * Store.state.inchCom
  var scrrenL, scrrenW, x
  var aspectRatioNo = ratio
  scrrenL = aspectRatioNo.split(':')[0]
  scrrenW = aspectRatioNo.split(':')[1]
  x = Math.sqrt(Math.pow(screenSize, 2) /
  (Math.pow(scrrenL, 2) + Math.pow(scrrenW, 2))
  )
  return {
    calX: scrrenL * x,
    calY: scrrenW * x
  }
}

/**
 * 已知屏幕长calX，比例ratio，求取屏幕大小inch
 */
commonViewJs.getScreenSizeByCalX = function (calX, ratio) {
  var scrrenL, scrrenW
  var aspectRatioNo = ratio
  scrrenL = aspectRatioNo.split(':')[0]
  scrrenW = aspectRatioNo.split(':')[1]
  let calY = calX / scrrenL * scrrenW
  let screenSize = Math.sqrt(Math.pow(calX, 2) + Math.pow(calY, 2))
  return {
    size: screenSize / Store.state.inchCom,
    calY: calY
  }
}
/**
 * 已知屏幕高calY，比例ratio，求取屏幕大小inch
 */
commonViewJs.getScreenSizeByCalY = function (calY, ratio) {
  var scrrenL, scrrenW
  var aspectRatioNo = ratio
  scrrenL = aspectRatioNo.split(':')[0]
  scrrenW = aspectRatioNo.split(':')[1]
  let calX = calY / scrrenW * scrrenL
  let screenSize = Math.sqrt(Math.pow(calX, 2) + Math.pow(calY, 2))
  return {
    size: screenSize / Store.state.inchCom,
    calX: calX
  }
}

commonViewJs.isLongLensExistsLens = function () {
  return Store.state.selectedModelData.type === 0 && Store.state.selectedLensData.lcd.lensShiftRange.v.min === 0 && Store.state.selectedLensData.lcd.lensShiftRange.v.max === 0
}

commonViewJs.isLongLensExistsTLens = function () {
  return Store.state.selectedLensData.lcd.distInfo[0].tv.tv1 !== 0 && Store.state.selectedLensData.lcd.distInfo[0].tv.tv2 !== 0
}

/**
 * 通过房间信息确定投影仪最大距离
 */
commonViewJs.getMaxDisByRoom = function () {
  if (Store.state.isOutOfSpec) {
    return Number.POSITIVE_INFINITY
  }
  var scrrenL, scrrenW, scSize
  var aspectRatioNo = Store.state.selectedLensData.lcd.aspectRatio
  scrrenL = aspectRatioNo.split(':')[0]
  scrrenW = aspectRatioNo.split(':')[1]
  if (Store.state.houseInfo.roomW / Store.state.houseInfo.roomH < scrrenL / scrrenW) {
    scSize = Math.sqrt(Math.pow(Store.state.houseInfo.roomW, 2) + Math.pow(Store.state.houseInfo.roomW / (scrrenL / scrrenW), 2)) / Store.state.inchCom
  } else {
    scSize = Math.sqrt(Math.pow(Store.state.houseInfo.roomH, 2) + Math.pow(Store.state.houseInfo.roomH * (scrrenL / scrrenW), 2)) / Store.state.inchCom
  }
  return this.calScreensizeInitToDistanceWide(scSize) + Store.state.offset - 0.1
}

/**
 * 通过镜头信息最小（最大）屏幕计算投影仪的最小（最大）距离
 */
commonViewJs.getMinDisByLens = function () {
  let distInfoVal = Store.state.selectedLensData.lcd.distInfo.find(item => item.ratio === Store.state.aspectRatio)

  var maxDis = this.calScreensizeToDistanceWide(distInfoVal.screenSize.w.max) + Store.state.offset
  var minDis = this.calScreensizeToDistanceWide(distInfoVal.screenSize.w.min) + Store.state.offset
  return {
    maxDis: maxDis,
    minDis: minDis
  }
}

commonViewJs.isAvlExist = function () {
  if (Store.state.graph.f_s2d.t) {
    return true
  } else {
    return false
  }
}

commonViewJs.isOffsetExist = function () {
  if (Store.state.offset !== 0) {
    return true
  } else {
    return false
  }
}

// 获取屏幕距离投影仪计算公式
commonViewJs.calScreensizeToDistanceTele = function (screenSize) {
  if (Store.state.graph.f_s2d.t.a === 0 && Store.state.graph.f_s2d.t.b === 0) {
    return this.calScreensizeToDistanceWide(screenSize)
  }
  let FNumVal = Store.state.selectedLensData.fNum
  let wideDistMax = this.calScreensizeToDistanceWide(Store.state.ratioScreenSizeMax)
  let teleDist = Store.state.graph.f_s2d.t.a * screenSize + Store.state.graph.f_s2d.t.b
  if (FNumVal.indexOf('-') === -1 && teleDist >= wideDistMax) {
    // return this.calScreensizeToDistanceWide(screenSize)
    // 電子ズームの調整範囲修正
    return this.calScreensizeToDistanceWide(Store.state.ratioScreenSizeMax)
  } else {
    return teleDist
  }
}
commonViewJs.calScreensizeToDistanceWide = function (screenSize) {
  return Store.state.graph.f_s2d.w.a * screenSize + Store.state.graph.f_s2d.w.b
}
commonViewJs.calScreensizeInitToDistanceWide = function (screenSize) {
  let distInfoVal = this.filterDistInfoByAspactRatio()
  return distInfoVal.size2dist.w.a * screenSize + distInfoVal.size2dist.w.b
}
commonViewJs.calDistanceInitToScreensizeWide = function (dist) {
  let distInfoVal = this.filterDistInfoByAspactRatio()
  return distInfoVal.dist2size.w.a * dist + distInfoVal.dist2size.w.b
}

commonViewJs.getKy = function () {
  return this.calScreensizeToDistanceWide(Store.state.screenSize) + Store.state.offset
}
commonViewJs.getKz = function () {
  return Store.state.graph.pjZ + Store.state.initScreenSize.h * Store.state.graph.vLensShift.min - Store.state.initScreenSize.h * Store.state.vLensShiftNow / 100
}
commonViewJs.getLy = function () {
  return this.calScreensizeToDistanceTele(Store.state.screenSize) + Store.state.offset
}
commonViewJs.getLz = function () {
  return Store.state.graph.pjZ + Store.state.initScreenSize.h * Store.state.graph.vLensShift.max - Store.state.initScreenSize.h * Store.state.vLensShiftNow / 100
}

commonViewJs.getPx = function () {
  return Store.state.graph.pjX + Store.state.initScreenSize.w * Store.state.graph.hLensShift.max + Store.state.initScreenSize.w * Store.state.hLensShiftNow / 100
}
commonViewJs.getPy = function () {
  return this.calScreensizeToDistanceWide(Store.state.screenSize) + Store.state.offset
}
commonViewJs.getQx = function () {
  return Store.state.graph.pjX - Store.state.initScreenSize.w * Math.abs(Store.state.graph.hLensShift.min) + Store.state.initScreenSize.w * Store.state.hLensShiftNow / 100
}
commonViewJs.getQy = function () {
  return this.calScreensizeToDistanceTele(Store.state.screenSize) + Store.state.offset
}
commonViewJs.filterDistInfoByAspactRatio = function () {
  let distInfoVal = Store.state.selectedLensData.lcd.distInfo.find(item => item.ratio === Store.state.selectedLensData.lcd.aspectRatio)
  return distInfoVal
}

export default commonViewJs
